import { render, staticRenderFns } from "./PublicChatsFilters.vue?vue&type=template&id=59c44272&"
import script from "./PublicChatsFilters.vue?vue&type=script&lang=js&"
export * from "./PublicChatsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports